import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import queryString from 'query-string';
import { Element } from 'react-scroll';

import Highlighter from 'react-highlight-words';

import { TextWrapper } from './Text.style';
import { generateRowId, normalizeString, tryParseJson } from 'lib/utils/helper';

export const Text = ({ children }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [search, setSearch] = useState('');

  const resetSearchParmas = () => {
    const currentParams = {};

    for (let entry of searchParams.entries()) {
      currentParams[entry[0]] = entry[1];
    }

    setSearchParams({
      ...currentParams,
      search: '',
      rowId: '',
      rowIds: ''
    });

    setSearch('');
  };

  useEffect(() => {
    const _searchParams = queryString.parse(searchParams.toString());

    const searchStr = _searchParams.search || '';
    const rowIds = tryParseJson(_searchParams.rowIds);

    if (searchStr) {
      setSearch(searchStr);
    }

    if (rowIds?.length && rowIds.includes(normalizeString(children))) {
      setSearch(children);
    }
  }, [searchParams, search]);

  return (
    <Element key={generateRowId(children)} name={generateRowId(children)}>
      <TextWrapper onClick={() => resetSearchParmas()}>
        <Highlighter
          highlightClassName="highlighted"
          searchWords={[search]}
          autoEscape={true}
          textToHighlight={children}
        />
      </TextWrapper>
    </Element>
  );
};
